<div class="score-detail-view">
  <div class="detail-section">
    <div class="columns-left">
      <div>
        <label [for]="studentName">
          {{ 'shared-score-detail-field-student' | translate }}:
        </label>
        <span id="studentName" class="detail-value">
        {{ studentName }}
        </span>
      </div>

      <div>
        <label [for]="activityName">
          {{ 'shared-student-activity-report-activity' | translate }}:
        </label>
        <span id="activityName" class="detail-value">
          {{ activityName }}
        </span>
      </div>
      @if (wordListLevel) {
        <div>
          <label [for]="wordListLevel">
            {{ 'parent-report-wordList-field' | translate }}:
          </label>
          <span id="wordListLevel" class="detail-value">
              {{ wordListLevel }}
            </span>
        </div>
      }
    @if (showCompletedOn) {
      <div>
        <label for="completedOn">
          {{ 'shared-score-detail-field-date-time-completed' | translate }}:
        </label>
        <span id="completedOn" class="detail-value">
          @if (completedOn) {
            {{ completedOn | date: DATE_AND_TIME_FORMAT }}
          } @else {
            {{ 'shared-score-detail-field-date-time-completed-empty-message' | translate }}
          }
        </span>
      </div>
    }
      @if (showLastOverriddenMessage) {
        <div class="info-box">
          <span id="lastOverridden" class="overridden-message">
            {{ 'shared-score-detail-field-last-overridden' | translate: { userName: lastOverriddenUserName, overriddenDate: lastOverriddenOn | date: DATE_AND_TIME_FORMAT } }}
          </span>
        </div>
      }
    </div>
    <div class="columns-right">
      <div>
        <label [for]="className">
          {{ 'shared-score-detail-field-class' | translate }}:
        </label>
        <span id="className" class="detail-value">
          {{ className }}
        </span>
      </div>
      <div>
        <label [for]="productName">
          {{ 'parent-report-product-field' | translate }}:
        </label>
        <span id="productName" class="detail-value">
        {{ productName }}
      </span>
      </div>
    </div>
  </div>
  <div *ngIf="!showSpinner; else preloader;" class="score-table">
    <zbp-data-table
      [columns]="columns"
      [rows]="rows"
      [colorPrint]="true"
      [printableHeaders]="printableHeaders"
    />
  </div>

  <ng-template #preloader>
    <div class="preloader spinner">
      <zbp-preloader></zbp-preloader>
    </div>
  </ng-template>
</div>
